const styles = (theme) => ({
  root: {
    height: 50,
    '& fieldset': {
      borderColor: theme.color.grey_medium,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.color.grey_medium,
      borderBottomColor: theme.palette.primary.main,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: `1px solid ${theme.color.grey_medium}`,
      borderBottomColor: theme.palette.primary.main,
      borderBottomWidth: 2,
    },
  },

  headerSearch: {
    height: 20,

    '& fieldset': {
      border: 0,
    },
  },

  searchIcon: {
    width: 16,
    height: 16,
    cursor: 'pointer',
  },

  adornedEnd: {
    '& svg': {
      width: 20,
      height: 20,
      cursor: 'pointer',
      transition: 'fill .3s',
    },

    '&:hover': {
      '& svg': {
        fill: theme.color.teal,
      },
    },
  },
});

export default styles;
